<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container>
        <v-card class="card">
            <v-card-text>
                <h1 class="titulo mb-3">CADASTRO DE SISTEMA DE TERCEIROS</h1>
                <m-form ref="form">
                    <v-row class="text-center ml-5">
                        <v-col cols="12" md="6">
                            <m-text-field label="Nome do sistema: *"
                                          placeholder="Digite o nome do sistema"
                                          id="FieldNomeSistema"
                                          v-input-filter="[$filters.text]"
                                          :rules="[$rules.required]"
                                          v-model="nome_sistema"
                                          required
                                          outlined />
                            <m-text-field label="E-mail do técnico: *"
                                          placeholder="Digite o e-mail do técnico"
                                          id="FieldNomeTecnico"
                                          v-input-filter="[$filters.email]"
                                          :rules="[$rules.required, $rules.email]"
                                          v-model="email_tecnico"
                                          outlined />
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-select
                                    label="Empresa:"
                                    placeholder="Selecione a empresa"
                                    class="required"
                                    outlined
                                    :items="empresa"
                                    item-text="label"
                                    item-value="cd_empresa"
                                    :rules="[$rules.required]"
                                    v-model="empresa_selecionada" />
                            <v-select
                                    label="Unidades de negócio logado:"
                                    placeholder="Selecione a unidade de negócio"
                                    class="required"
                                    outlined
                                    :items="unidade"
                                    item-text="label"
                                    item-value="cd_unidade"
                                    :rules="[$rules.required]"
                                    v-model="unidade_selecionada" />
                        </v-col>
                    </v-row>
                </m-form>
                <v-row class="pr-5 ml-8 justify-space-between">
                    <v-btn id="ButtonVoltar" color="secondary" @click="limpar()">Limpar</v-btn>

                    <v-btn id="ButtonProsseguir" class="d-flex" style="flex: none" color="primary" @click="salvar()">
                        Salvar
                    </v-btn>
                </v-row>
            </v-card-text>
        </v-card>
        <br>
        <br>
        <v-card>
            <v-card-text>
                <v-layout class="d-flex justify-space-between flex-wrap">
                    <v-btn class="transition" color="primary" rounded @click="filter_open = !filter_open">
                        <v-icon small style="margin-right: 10px;">rod-filter</v-icon>
                        Filtrar por:
                        <v-icon :class="{ 'rotate90': filter_open }" small>chevron_right</v-icon>
                    </v-btn>
                    <v-btn class="px-md-5 px-10 transition mt-2" color="primary" @click="download()">
                        <v-icon left size="18">
                            mdi-file-chart
                        </v-icon>
                        SALVAR RELATÓRIO
                    </v-btn>
                </v-layout>
                <collapse-transition>
                    <m-form ref="filter"
                            class="mt-8"
                            v-show="filter_open">
                        <v-row>
                            <v-col cols="12" sm="4">
                                <m-text-field label="Nome do sistema:"
                                              placeholder="Digite o nome do sistema"
                                              outlined
                                              v-model="filters.nm_sistema"
                                              v-input-filter="[$filters.text]" />
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <m-text-field label="E-mail do técnico:"
                                              placeholder="Digite o e-mail do técnico"
                                              outlined
                                              v-model="filters.email_tecnico"
                                              v-input-filter="[$filters.email]" />
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-select
                                        label="Empresas:"
                                        placeholder="Selecione a empresa"
                                        class="required"
                                        outlined
                                        :items="empresa"
                                        item-text="label"
                                        item-value="cd_empresa"
                                        v-model="filters.empresa_selecionada_filtro" />
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-select
                                        label="Unidades de negócio logado:"
                                        placeholder="Selecione a unidade de negócio"
                                        class="required"
                                        outlined
                                        :items="unidade"
                                        item-text="label"
                                        item-value="cd_unidade"
                                        v-model="filters.unidade_selecionada_filtro" />
                            </v-col>
                        </v-row>
                        <v-row class="justify-space-between">
                            <v-col cols="6" sm="3">
                                <v-btn color="secondary" block @click="limparFiltro">
                                    Limpar
                                </v-btn>
                            </v-col>
                            <v-col cols="6" sm="3">
                                <v-btn color="primary" block @click="filtrar">
                                    Filtrar
                                </v-btn>
                            </v-col>
                        </v-row>
                    </m-form>
                </collapse-transition>
            </v-card-text>
            <DataTable
                    url="/painel/listar_terceiro"
                    :headers="headers"
                    :params="params"
                    item-key="id_parceiro"
                    :value="parceiros_selecionados"
                    class="listagem"
                    ref="datatable"
                    :filter="search">
                <template v-slot:items="{item}">
                    <td>
                        <v-menu :close-on-content-click="false">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn color="primary" class="btn-acoes"
                                       v-bind="attrs"
                                       v-on="on">
                                    <v-icon>mdi-dots-horizontal</v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-item>
                                    <v-list-item-title class="font-weight-bold">O que deseja fazer?</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="excluirParceiro([item])">
                                    <v-list-item-title>Excluir</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </td>
                    <td>{{ item.nm_sistema }}</td>
                    <td>{{ item.email_tecnico }}</td>
                    <td>{{ item.cd_empresa }}</td>
                    <td>{{ item.cd_un_negocio }}</td>
                    <td>{{ item.client_id }}</td>
                </template>
            </DataTable>
        </v-card>
        <br>
    </v-container>
</template>

<script>
  import { alert, sleep, notification } from '@/plugins/helpers'
  import { mapState } from 'vuex'
  import * as Qs from 'qs'
  import { AlertTypes } from '@/plugins/alerts_types'

  export default {
    name: 'GerenciamentoTerceiros',
    data: () => ({
      headers: [
        { text: 'Ações ' },
        { text: 'Nome do sistema', value: 'nm_sistema' },
        { text: 'Email do técnico', value: 'email_tecnico' },
        { text: 'Empresa', value: 'cd_empresa' },
        { text: 'Unidades de negócio', value: 'cd_un_negocio' },
        { text: 'Client_id', value: 'client_id' }
      ],
      custom_filter: {

      },
      nome_sistema: '',
      email_tecnico: '',
      empresa_selecionada: '',
      empresas_nomes: [],
      unidade_selecionada: '',
      unidades_nomes: [],
      parceiros_selecionados: [],
      editar: false,
      filter_open: false,
      filters: {
        nm_sistema: '',
        empresa_selecionada_filtro: '',
        unidade_selecionada_filtro: '',
        email_tecnico: ''
      },
      search: {},
      page: 1,
      itemsPerPage: 15,
      items: [],
      id_cadastro: null
    }),
    computed: {
      ...mapState([ 'empresas' ]),
      ...mapState([ 'unidades' ]),

      empresa () {
        const empresas = this.$session.get('empresas').map(empresas => ({ id_empresa: empresas.ID_Empresa, nome: empresas.NM_Empresa.toUpperCase(), label: `${empresas.CD_Empresa} - ${empresas.NM_Empresa}`, cd_empresa: empresas.CD_Empresa }))
        return empresas.sort(this.ordernar)
      },
      unidade () {
        const unidades = this.$session.get('unidades').map(unidades => ({ id_unidade: unidades.id_unidade_negocio, nome: unidades.nm_unidade_negocio, label: `${unidades.cd_unidade_negocio} - ${unidades.nm_unidade_negocio.toUpperCase()}`, cd_unidade: unidades.cd_unidade_negocio }))
        return unidades.sort(this.ordenar)
      },
      MAX_EMPRESAS: () => 1,
      MAX_UNIDADES: () => 1,
      params () {
        return {
          pagination: {
            rowsPerPage: 15,
            items_grid: 15,
            sortBy: 'tb_cadastro_terceiros.created_at',
            descending: true
          },
          custom_filter: this.customFilter
        }
      }
    },
    methods: {
      salvar () {
        try {
          const form = this.$refs.form
          if (form.validate()) {
            if (this.nome_sistema && this.email_tecnico && this.empresa_selecionada && this.unidade_selecionada) {
              this.$http.post('/painel/cadastrar_terceiro', {
                params: {
                  nome_sistema: this.nome_sistema,
                  email_tecnico: this.email_tecnico,
                  cd_empresa: this.empresa_selecionada,
                  cd_un_negocio: this.unidade_selecionada
                }
              }).then(result => {
                if (result.data.msg) {
                  this.nome_sistema = ''
                  this.email_tecnico = ''
                  this.empresa_selecionada = ''
                  this.unidade_selecionada = ''
                  this.$refs.datatable.reload()
                  notification(AlertTypes.SUCCESS, `${result.data.msg}`)
                  this.$refs.form.reset()
                } else {
                  notification(AlertTypes.ERROR, `${result.data.msg_erro}`)
                }
              })
            } else {
              notification(AlertTypes.WARN, 'Campos obrigatórios não preenchidos!')
            }
          } else {
            form.resetValidation()
            sleep(100).then(() => form.validate())
          }
        } catch (e) {
          notification('error', e, 'Falha ao cadastrar novo sistema de terceiro. Tente novamente mais tarde!!')
        }
      },
      limpar () {
        this.$refs.form.reset()
      },
      excluirParceiro (item) {
        alert({
          text: 'Tem certeza que deseja excluir o cadastro selecionado?\nOs dados atuais não serão salvos.',
          buttons: {
            'Cancelar': () => true,
            'Confirmar': () => {
              this.$http.post('/painel/excluir_cadastro_terceiro', { params: {
                itens: item
              } }).then(result => {
                if (result.data.msg) {
                  this.$refs.datatable.reload()
                  notification(AlertTypes.SUCCESS, `${result.data.msg}`)
                  this.$refs.form.reset()
                } else {
                  notification(AlertTypes.ERROR, `${result.data.Msg_Erro}`)
                }
              })
            }
          }
        })
      },
      download () {
        const filtros = { ...this.filters }
        const encoded_params = Qs.stringify({
          filter: filtros,
          pagination: { sortBy: this.params.pagination.sortBy, descending: this.params.pagination.descending },
          headers: this.headers.map(header => header.value),
          headers_formatado: this.headers.map(header => header.text)
        }, {
          arrayFormat: 'brackets',
          encode: true
        })
        try {
          window.open(`${this.ws}/cadastro_terceiros/exportar?${encoded_params}`)
        } catch (error) {
          notification(AlertTypes.ERROR, `${error.response?.data?.error || error.message}`)
        }
      },
      scrollToTop () {
        window.scrollTo(0, 0)
      },
      limparFiltro () {
        this.$refs.form.resetValidation()
        this.filters = {
          nm_sistema: '',
          empresa_selecionada_filtro: '',
          unidade_selecionada_filtro: '',
          email_tecnico: ''
        }
        this.filtrar()
        this.filter_open = false
        this.$refs.datatable.reload()
      },
      filtrar () {
        this.page = 1
        if (this.$refs.filter.validate()) {
          this.search = { ...this.filters }
        }
      }
    }
  }
</script>

<style scoped lang="scss">
    .v-btn:not(.v-btn--round).v-size--default.btn-acoes {
        padding: 0;
        min-width: 0;
        width: 48px;
    }
    .botoes-acao .v-btn {
        flex: 1;
    }
    .tooltip-ajuda {
        height: 24px;
        position: relative;
        .tooltip-ajuda-text {
            position: absolute;
            background: #FFF;
            padding: 5px;
            border: 2px solid var(--primary);
            bottom: 100%;
            right: 0;
            z-index: -1;
            margin-bottom: 0;
            opacity: 0;
            transition: all ease 500ms !important;
        }
        &:hover .tooltip-ajuda-text {
            opacity: 1;
            z-index: 1;
        }
    }
</style>
